import { Input } from '@weareopenr/component-library';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { ICreateTimetableFormValues } from '../types';
import styles from './TimetableNameField.module.scss';

export const DUPLICATE_NAME_ERROR = 'Name must be unique for the brand';

interface TimetableNameFieldProps {
  register: UseFormRegister<ICreateTimetableFormValues>;
  errors: FieldErrors<ICreateTimetableFormValues>;
  existingNames?: string[];
}

export const TimetableNameField = ({ register, errors, existingNames = [] }: TimetableNameFieldProps) => (
  <div className={styles['name-field']}>
    <Input
      type="text"
      label="Timetable Name (internal only)"
      register={register('name', {
        required: 'Please enter a timetable name',
        validate: {
          notEmpty: (value) => value.trim().length > 0 || 'Please enter a timetable name',
          isUnique: (value) => {
            const trimmedValue = value.trim().toLocaleLowerCase();
            const isDuplicate = existingNames.some((name) => name.toLocaleLowerCase() === trimmedValue);
            return !isDuplicate || DUPLICATE_NAME_ERROR;
          },
        },
      })}
      error={errors?.name?.message}
    />
  </div>
);

export default TimetableNameField;
